//downgraded services from angular17
import { Router } from '@angular/router';
import { downgradeInjectable } from '@angular/upgrade/static';
import { LoggedInUserStore } from '@logged-in-user-store';
import pims from '../../angularJs/src/app/index.module.ajs';
import { GpLettersService } from './services/gp-letters/gp-letters.service';
import { SnackNotificationsDialogService } from '@ui-lib/services';
import { RefillResponsesStoreStore } from '@refill-responses-store';
import { Injectable } from '@angular/core';
import { FillsEndpoints } from '@pims-endpoints';
import { MedicationsByServiceAPI } from './api/cms/admin/medications/all/slugs/service-code/medications-by-service.service';
import { MessagingDialogService } from '@messaging/components/services';
import { VisitBridgeStore } from '@visit-bridge';
// Endpoint service wrappers for downgrade
@Injectable({ providedIn: 'root' })
export class FillsEndpointsAngularJS extends FillsEndpoints {}

export function loadDowngradedServices() {
  pims.factory('GpLettersService', downgradeInjectable(GpLettersService));
  pims.factory('LoggedInUserStore', downgradeInjectable(LoggedInUserStore));
  pims.factory('NgRouter', downgradeInjectable(Router));
  pims.factory('snackBar', downgradeInjectable(SnackNotificationsDialogService));
  pims.factory('RefillResponsesStoreStore', downgradeInjectable(RefillResponsesStoreStore));
  pims.factory('FillsEndpoints', downgradeInjectable(FillsEndpointsAngularJS));
  pims.factory('MedicationsByServiceAPI', downgradeInjectable(MedicationsByServiceAPI));
  pims.factory('MessagingDialogService', downgradeInjectable(MessagingDialogService));
  pims.factory('VisitBridgeStore', downgradeInjectable(VisitBridgeStore));
}
